import React, { useEffect } from 'react';

import { useRouter } from 'next/router';

import { FaChevronLeft } from 'react-icons/fa';

import User from 'components/User';
import { AuthorSectionProps } from 'components/User/ContributionSection';
import { usePosterWithThumbnail } from 'containers/SubmissionsList/hooks';
import { ProfilePageProps } from 'pages/event/[eventId]/people/[userId]';
import { useAuthContext } from 'store';
import { logEvent } from 'utils/eventTracking';

import * as ContainerStyles from '../styles';

export const ProfileInfo: React.FC<ProfilePageProps['data']> = ({
  userId,
  event,
  profile,
  author,
  speaker,
  chair,
}) => {
  const { push } = useRouter();
  const { data: authorList } = usePosterWithThumbnail(event.id, author);
  const { state: authUser } = useAuthContext();
  const authUserId = authUser?.profile?.id;

  useEffect(() => {
    if (authUserId !== userId && profile?.public_profile) {
      logEvent('VIEWED_PROFILE_PAGE', {
        id: userId,
      });
    }
  }, [authUserId, profile?.public_profile, userId]);

  return (
    <>
      <ContainerStyles.Backbutton
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
        onClick={() => {
          logEvent('BACK_LINK_CLICKED', {
            event_position: 'PROFILE_PAGE',
          });
          push(`/event/${event.id}/people`);
        }}
      >
        <FaChevronLeft className="mr1" />
        All People
      </ContainerStyles.Backbutton>
      <User
        userId={userId}
        event={event}
        profile={profile}
        author={authorList as AuthorSectionProps[]}
        speaker={speaker}
        chair={chair}
        selectParticipant={() => null}
      />
    </>
  );
};
